import { ca } from '@cian/analytics';

import { ITracking } from '../../types/tracking';

export const trackPhonesOpen = (products: ITracking['products']) => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'open_specialist',
    category: 'Phones',
    label: 'company',
    products,
  });
};
